/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-08 16:30:42
 * @FilePath: /unifyxp-v2-store-portal/src/layout/MainPagesLayout/MainPagesLayout.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import { menuArray } from '@/src/config/SiderConfig/MainPageSIderConfig';
import T from 'src/layout/Components/PageStructure/PageStructure';
import Trigger from 'src/layout/Components/CollapseTrigger/Trigger';
import { useSelector } from 'react-redux';
import css from './css.less';

const MainLayout = (props) => {
  const collapsed = useSelector(
    (state: any) => state.mainLayout.isSiderCollapsed,
  );
  //console.log('render');

  // const redux = useSelector((state: any) => state);
  // const currentSalesChannel = useSelector(
  //   (state: any) => state.currentSalesChannel,
  // );
  // console.log(redux);
  // console.log(currentSalesChannel);
  // useFetchSalesChannel();
  // setTimeout(() => {
  //   console.log(onClearStoredSalesChannel);
  // }, 1000);
  // console.log(onClearStoredSalesChannel);
  //useFetchCurrentDatabase();
  //useClearSalesChannel();

  return (
    <React.Fragment>
      <T
        menuArray={menuArray}
        siderClassName={css.trigger}
        trigger={<Trigger open={!collapsed} />}>
        {props.children}
      </T>
    </React.Fragment>
  );
};

export default MainLayout;
